
export const ValueType = {
  valueTypeOptions: [{ label: 'type1', value: 1, active: true },
    { label: 'type2', value: 2, active: true },
    { label: 'type3', value: 3, active: true }],
  i18nKey: 'valueTypeT',
  zhCn: {
    valueTypeT: {
      type1: '字符串',
      type2: '整数',
      type3: '小数'
    }
  },
  en: {
    valueTypeT: {
      type1: '字符串',
      type2: '整数',
      type3: '小数'
    }
  }
}
